export const EPageTypeGetParam = {
  TAB: 'tab',
  GRID2D_OFFSET: 'grid2d_offset',
};
